"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.defaultOffset = exports.defaultLimit = exports.defaultOrderByOptions = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/briefcase/list");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.defaultOrderByOptions = {
    orderBy: 'id',
    order: 'asc'
};
exports.defaultLimit = 350;
exports.defaultOffset = 0;
exports.initialState = {
    status: exports.STANDBY,
    list: [],
    limit: exports.defaultLimit,
    offset: exports.defaultOffset,
    itemsPerPage: [350, 700, 1400],
    searchString: '',
    orderByOptions: Object.assign({}, exports.defaultOrderByOptions),
    filterOptions: {}
};
const statusLens = monocle.Lens.fromProp('status');
const listLens = monocle.Lens.fromProp('list');
const limitLens = monocle.Lens.fromProp('limit');
const offsetLens = monocle.Lens.fromProp('offset');
const searchStringLens = monocle.Lens.fromProp('searchString');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
exports.methods = {};
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(listLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
exports.methods[ActionTypes.BOOKMARK_REQUEST] = (state, action) => listLens.modify((x) => x.map((y) => y.id === action.payload.briefcase.id
    ? Object.assign(Object.assign({}, action.payload.briefcase), { bookmarked: action.payload.status }) : y))(state);
exports.methods[ActionTypes.BOOKMARK_FAILED] = (state, action) => listLens.modify((x) => x.map((y) => (y.id === action.briefcase.id ? action.briefcase : y)))(state);
exports.methods[ActionTypes.SET_INIT_DATA] = (state, action) => {
    const _a = action.payload, { search, order, orderBy, limit, offset } = _a, filters = __rest(_a, ["search", "order", "orderBy", "limit", "offset"]);
    return fp.function.compose(searchStringLens.set(search || ''), orderByOptionsLens.modify((x) => {
        const clone = Object.assign({}, x);
        if (orderBy) {
            clone.orderBy = orderBy;
        }
        if (order === 'asc' || order === 'desc') {
            clone.order = order;
        }
        return clone;
    }), limitLens.modify((x) => {
        const l = parseInt(limit || '', 10);
        if (isNaN(l)) {
            return x;
        }
        return l;
    }), offsetLens.modify((x) => {
        const o = parseInt(offset || '', 10);
        if (isNaN(o)) {
            return x;
        }
        return o;
    }), filterOptionsLens.set(filters))(state);
};
exports.methods[ActionTypes.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_PAGINATION_OPTIONS] = (state, action) => fp.function.compose(limitLens.set(action.payload.limit), offsetLens.set(action.payload.offset))(state);
exports.methods[ActionTypes.SET_COLUMN_FILTER] = (state, action) => filterOptionsLens.modify((x) => {
    const clone = Object.assign({}, x);
    const { field, value } = action.payload;
    if (value === undefined) {
        delete clone[field];
    }
    else {
        clone[field] = value;
    }
    return clone;
})(state);
exports.methods[ActionTypes.SET_ORDER_BY] = (state, action) => orderByOptionsLens.set(action.payload)(state);
//# sourceMappingURL=list.js.map